/**
 * FT13-U28: financial statement sets (FSD 2.2.8 Generate Statements / Publish).
 * `/close/statements/:id` is the target of the FT12 "statements published"
 * notification (server close/statement_set.go). Spread by INT into the router;
 * no module entitlement, like every close route.
 */

import type { RouteRecordRaw } from 'vue-router'

import { STATEMENT_PERMISSIONS } from '@/modules/close/statements/api'

export const CLOSE_STATEMENTS_ROUTES: RouteRecordRaw[] = [
  {
    path: '/close/statements',
    name: 'close-statements',
    component: () => import('@/modules/close/statements/StatementSetsView.vue'),
    meta: { titleKey: 'close.ft13.routeTitles.statements', permission: STATEMENT_PERMISSIONS.read },
  },
  {
    path: '/close/statements/:id(\\d+)',
    name: 'close-statement',
    component: () => import('@/modules/close/statements/StatementSetView.vue'),
    meta: { titleKey: 'close.ft13.routeTitles.statement', permission: STATEMENT_PERMISSIONS.read },
  },
]
